/* ==========================================================================
   assets/pi-consent.js
   Баннер согласия на куки Paws Impérial.

   Зачем свой, а не встроенный в Shopify: встроенный почти не оформляется
   и показывается только в регулируемых регионах — на живом сайте он
   молча не рисовался. Этот выглядит как сайт и показывается всем.

   Решение посетителя пишется НЕ в свой localStorage, а через официальный
   Customer Privacy API — только так его видят пиксели и аналитика Shopify.
   Своё хранилище было бы красивой картинкой без последствий.

   ВАЖНО: встроенный баннер Shopify должен быть выключен в админке
   (Settings → Customer privacy → Cookie banner), иначе в ЕС покажутся оба.
   ========================================================================== */
(function () {
  'use strict';

  // Показывать всем на первом заходе. false — только там, где этого требует
  // закон (решает сам Shopify). Показ всем честнее, но срезает объём
  // аудитории для ретаргетинга: отказавшиеся в неё не попадут.
  var SHOW_EVERYWHERE = true;

  // Своя память о решении. Раньше показ плашки зависел только от хранилища
  // Shopify — а оно у части посетителей между страницами не переживает, и
  // плашка выскакивала на каждом переходе даже после «Accept all».
  // Теперь решение пишем сами, в два места: localStorage и первичную куку
  // на год. Одно не сработало (приватный режим, чистка при закрытии) —
  // остаётся второе.
  var KEY = 'pi-cc-decision';
  var COOKIE = 'pi_cc';
  var YEAR = 365 * 24 * 60 * 60;

  var TEXT = {
    eyebrow: 'Privacy',
    title: 'Cookie consent',
    body:
      'We and our partners, including Shopify, use cookies and similar technologies ' +
      'to run this site, remember your preferences, measure how it is used and show ' +
      'you relevant ads. You choose what we may use.',
    policy: 'Privacy Policy',
    accept: 'Accept all',
    decline: 'Decline',
    prefs: 'Manage preferences',
    save: 'Save choices'
  };

  // Четыре категории Customer Privacy API. Необходимые куки согласия не требуют
  // и в списке не участвуют — сайт без них просто не работает.
  var CATS = [
    ['analytics',   'Analytics',        'How many people visit, which pages they read, where they leave.'],
    ['marketing',   'Marketing',        'Lets us show our ads to people who looked at the site and left.'],
    ['preferences', 'Preferences',      'Remembers your choices, so the site does not ask twice.'],
    ['sale_of_data','Sharing with partners', 'Sharing activity with advertising partners. Decline and it stops.']
  ];

  var api = null;    // window.Shopify.customerPrivacy, когда поднимется
  var node = null;

  /* --- Разметка ---------------------------------------------------------- */

  function build() {
    var el = document.createElement('div');
    el.className = 'pi-cc';
    el.id = 'pi-cc';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-label', TEXT.title);

    var rows = CATS.map(function (c) {
      // Necessary-категории нет: снять её нельзя, показывать нечего
      return (
        '<label class="pi-cc__row">' +
          '<input type="checkbox" data-cc-cat="' + c[0] + '" checked>' +
          '<span><b>' + c[1] + '</b><span>' + c[2] + '</span></span>' +
        '</label>'
      );
    }).join('');

    el.innerHTML =
      '<div class="pi-cc__inner">' +
        '<div class="pi-cc__copy">' +
          '<p class="pi-cc__eyebrow">' + TEXT.eyebrow + '</p>' +
          '<h2 class="pi-cc__title">' + TEXT.title + '</h2>' +
          '<p class="pi-cc__text">' + TEXT.body +
            ' <a href="/pages/privacy-policy">' + TEXT.policy + '</a>.' +
          '</p>' +
        '</div>' +
        '<div class="pi-cc__btns">' +
          '<button type="button" class="pi-cc__btn pi-cc__btn--prefs"   data-cc="prefs">'   + TEXT.prefs   + '</button>' +
          '<button type="button" class="pi-cc__btn pi-cc__btn--decline" data-cc="decline">' + TEXT.decline + '</button>' +
          '<button type="button" class="pi-cc__btn pi-cc__btn--accept"  data-cc="accept">'  + TEXT.accept  + '</button>' +
        '</div>' +
      '</div>' +
      '<div class="pi-cc__prefs">' +
        '<div class="pi-cc__grid">' + rows + '</div>' +
        '<button type="button" class="pi-cc__btn pi-cc__btn--accept pi-cc__save" data-cc="save">' + TEXT.save + '</button>' +
      '</div>';

    el.addEventListener('click', onClick);
    document.body.appendChild(el);
    return el;
  }

  function onClick(e) {
    var btn = e.target.closest('[data-cc]');
    if (!btn) return;
    var act = btn.getAttribute('data-cc');

    if (act === 'prefs')   { node.classList.add('is-prefs'); return; }
    if (act === 'accept')  { apply(all(true));  return; }
    if (act === 'decline') { apply(all(false)); return; }
    if (act === 'save')    { apply(picked());   return; }
  }

  function all(v) {
    var o = {};
    CATS.forEach(function (c) { o[c[0]] = v; });
    return o;
  }

  function picked() {
    var o = {};
    CATS.forEach(function (c) {
      var box = node.querySelector('[data-cc-cat="' + c[0] + '"]');
      o[c[0]] = !!(box && box.checked);
    });
    return o;
  }

  /* --- Сохранение решения ------------------------------------------------ */

  function apply(choice) {
    hide();
    remember(choice);
    push(choice);
  }

  // Отдаём решение в Shopify. Вызывается и при выборе, и на каждой следующей
  // странице — чтобы пиксели видели тот же выбор, что записан у нас, даже
  // если своё хранилище Shopify его потеряло.
  // Метку при ошибке НЕ снимаем: человек ответил, и переспрашивать его на
  // каждой странице нельзя. Ошибку записываем в консоль.
  function push(choice) {
    if (!api || typeof api.setTrackingConsent !== 'function') return;
    try {
      api.setTrackingConsent(choice, function (res) {
        if (res && res.error) console.warn('[pi-cc] согласие не записано:', res.error);
      });
    } catch (err) {
      console.warn('[pi-cc] setTrackingConsent упал:', err);
    }
  }

  function readCookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m[2]) : null;
  }

  function remember(choice) {
    var raw = JSON.stringify(choice);
    try { localStorage.setItem(KEY, raw); } catch (err) {}
    try {
      document.cookie = COOKIE + '=' + encodeURIComponent(raw) +
        ';path=/;max-age=' + YEAR + ';SameSite=Lax' +
        (location.protocol === 'https:' ? ';Secure' : '');
    } catch (err) {}
  }

  // Сохранённый выбор или null. Смотрим оба хранилища.
  function recall() {
    var raw = null;
    try { raw = localStorage.getItem(KEY); } catch (err) {}
    if (!raw) raw = readCookie(COOKIE);
    if (!raw) return null;
    if (raw === '1') return all(true);          // метка старого формата
    try {
      var o = JSON.parse(raw);
      return (o && typeof o === 'object') ? o : all(true);
    } catch (err) { return all(true); }
  }

  function show() {
    node = node || build();
    node.classList.add('is-open');
    // два кадра: сначала display, потом трансформация — иначе анимации нет
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { node.classList.add('is-shown'); });
    });
  }

  function hide() {
    if (!node) return;
    node.classList.remove('is-shown');
    setTimeout(function () { node.classList.remove('is-open', 'is-prefs'); }, 420);
  }

  /* --- Решаем, показывать ли -------------------------------------------- */

  function decided(consent) {
    if (!consent) return false;
    return CATS.some(function (c) {
      var v = consent[c[0]];
      return v === 'yes' || v === 'no' || v === true || v === false;
    });
  }

  function start() {
    var S = window.Shopify;
    var saved = recall();                        // ПЕРВЫМ делом своя метка

    if (!S || typeof S.loadFeatures !== 'function') {
      // API недоступен (превью вне Shopify) — плашку показываем один раз
      if (!saved) show();
      return;
    }

    S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error) {
        console.warn('[pi-cc] Customer Privacy API не поднялся');
        if (!saved) show();                      // без API решает своя метка
        return;
      }

      api = window.Shopify.customerPrivacy;
      if (!api) { if (!saved) show(); return; }

      // Человек уже отвечал — плашку не показываем, а выбор заново отдаём
      // в Shopify: его хранилище могло не сохраниться, наше сохранилось.
      if (saved) { push(saved); return; }

      var consent = null;
      try { consent = api.currentVisitorConsent(); } catch (err) {}
      if (decided(consent)) return;              // ответил в прошлой версии скрипта

      if (!SHOW_EVERYWHERE && typeof api.shouldShowBanner === 'function') {
        if (!api.shouldShowBanner()) return;     // регион не требует
      }
      show();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
